var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1372 6.37001C23.5785 4.47876 21.4122 3.4375 19.0347 3.4375C17.6047 3.4375 16.2222 3.78498 14.9997 4.44748C13.7785 3.78498 12.396 3.4375 10.9647 3.4375C8.58724 3.4375 6.41975 4.47876 4.86225 6.37001C3.16725 8.42751 2.46475 11.2375 2.981 13.8863C4.19975 20.1313 10.5597 24.4938 13.2385 26.0788C13.7822 26.4 14.391 26.5613 14.9997 26.5613C15.6085 26.5613 16.2185 26.4013 16.7622 26.0788C19.4397 24.4925 25.801 20.1313 27.0197 13.8863C27.5347 11.2375 26.8322 8.42751 25.1372 6.37001ZM25.1785 13.5275C24.106 19.0263 18.2672 23.0088 15.806 24.465C15.3097 24.76 14.6897 24.7588 14.1935 24.465C11.7322 23.0088 5.89348 19.0263 4.82098 13.5275C4.40973 11.4225 4.96723 9.19248 6.30848 7.56248C7.50473 6.11123 9.15724 5.3125 10.9647 5.3125C12.2372 5.3125 13.4572 5.6625 14.4947 6.325C14.8022 6.52125 15.1972 6.52125 15.5047 6.325C16.5422 5.6625 17.7622 5.3125 19.0347 5.3125C20.841 5.3125 22.4947 6.11123 23.691 7.56248C25.0322 9.19248 25.5885 11.4213 25.1785 13.5275Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c9bb0b39.svg";
export { ForwardRef as ReactComponent };